import { render, staticRenderFns } from "./DeckTeaser.vue?vue&type=template&id=1cdb9fa1&"
import script from "./DeckTeaser.vue?vue&type=script&lang=js&"
export * from "./DeckTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports